"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerSelectNotificationEvent = void 0;
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _metaUserAction = require("../constants/metaUserAction");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const eventType = 'select_notification';
const triggerSelectNotificationEvent = notification => {
  const metaHierarchy = [_metaUserAction.META_USER_ACTION_APP_NAME, eventType
  // FIXME (ol): Source and Description is not returned from API
  // `${notification.Source}`, `${notification.Description}`
  ];
  UserAction.dispatch(metaHierarchy);
};
exports.triggerSelectNotificationEvent = triggerSelectNotificationEvent;
